import { getLocalStorageKey, removeLocalStorageKey, updateLocalStorageKey } from '../../utils';

const CONNECTED_SLACK_WORKSPACE_KEY_PREFIX = 'infi-slack-workspace-';

export const PLATFORM_SLACK_PRODUCT_KEY = 'platform';

export const getConnectedSlackWorkSpace = () =>
	getLocalStorageKey(`${CONNECTED_SLACK_WORKSPACE_KEY_PREFIX}${PLATFORM_SLACK_PRODUCT_KEY}`);

export const setConnectedSlackWorkSpace = (value: string) =>
	updateLocalStorageKey(
		`${CONNECTED_SLACK_WORKSPACE_KEY_PREFIX}${PLATFORM_SLACK_PRODUCT_KEY}`,
		value,
	);

export const disconnectSlackWorkSpace = (): void =>
	removeLocalStorageKey(`${CONNECTED_SLACK_WORKSPACE_KEY_PREFIX}${PLATFORM_SLACK_PRODUCT_KEY}`);
